export default () => {
  // const appbarHeight = 42;

  const appbarHamburgerSelector = '.appbar__hamburger[data-appbar="hamburger"]';
  const appbarHamburgerClassNameActive = 'appbar__hamburger--active';
  const appbarHamburger = $(appbarHamburgerSelector);

  const appbarMenuSelector = '.appbar__menu[data-appbar="hamburger"]';
  const appbarMenu = $(appbarMenuSelector);

  const appbarMenuLinksSelector = '[data-appbar-scroll-to-element]';
  const appbarMenuLinks = appbarMenu.find(appbarMenuLinksSelector);

  /**
   * Events setup
   */
  appbarHamburger.click(function() {
    appbarHamburger.toggleClass(appbarHamburgerClassNameActive);
    appbarMenu.fadeToggle();
  });

  appbarMenuLinks.click(function(e) {
    e.preventDefault();
   
    const appbarMenuLink = $(this);
    const appbarMenuLinkHref = appbarMenuLink.attr('href');
    const elementScrollTo = $(appbarMenuLinkHref);

    appbarHamburger.removeClass(appbarHamburgerClassNameActive);
    appbarMenu.fadeOut();
    appbarMenu.addClass('hidden');

    // $(".menu-list__item").each((index, element) => {
    //   $(element).removeClass("menu-list__item--active-link");
    // });

    // $(e.target).parent().addClass("menu-list__item--active-link");
    
    $('html, body').animate({
      // scrollTop: elementScrollTo.offset().top - $(".appbar").height()
      scrollTop: elementScrollTo.offset().top
    }, 900);
  });
};